import api from "../api";

export const getReviewOptions = async (entityType) => {
  const response = await api.get(`information/customer/reviews-options/`, {
    params: {
      entity_type: entityType,
    },
  });

  return response.data;
};

export const createCustomerReview = async (payload) => {
  const response = await api.post(
    `information/customer/reviews/`,
    payload
  );

  return response.data;
};

export const updateCustomerReview = async (reviewId, payload) => {
  const response = await api.patch(
    `information/customer/reviews/${reviewId}/`,
    payload
  );

  return response.data;
};

export const getCustomerReviewDetail = async (reviewId) => {
  const response = await api.get(
    `information/customer/reviews/${reviewId}/`
  );

  return response.data;
};

export const getAdminSupplierReviewDetail = async (reviewId) => {
  const response = await api.get(
    `information/reviews-detail/${reviewId}/`
  );

  return response.data;
};

export const deleteCustomerReview = async (reviewId) => {
  const response = await api.delete(
    `information/customer/reviews/${reviewId}/`
  );

  return response.data;
};
